import ForgetPassword from "../components/Welcome/ForgetPassword";

const ForgetPasswordPage = () => {
    return (
        <ForgetPassword />
    );
};


export default ForgetPasswordPage;